import _ from 'lodash'

import Card from 'admin/components/Card/Card'

import SearchResultsGroup from './SearchResultsGroup'

const Group = (props) => {
  const { label, list, loading, onClick } = props

  return (
    <SearchResultsGroup key={label} label={label} loading={loading}>
      {_.map(list, (item = {}) => {
        const { id, to, label, subtitle, note } = item

        const key = `${id} - ${to}`
        if (!id && to) {
          // a dev tools search result
          return <Card key={key} note={note} onClick={onClick} subtitle={subtitle} title={label} to={to} />
        }

        // an peach platform object
        return <Card key={key} model={item} onClick={onClick} />
      })}
    </SearchResultsGroup>
  )
}

const SearchResults = (props) => {
  const { loading, results, onClick } = props

  const grouped = _.groupBy(results, 'group')

  const displayGroups = _.compact(
    _.map(grouped, (group, key) => {
      if (!_.isEmpty(group)) {
        return <Group key={key} label={key} list={group} loading={loading} onClick={onClick} />
      }
    }),
  )

  return displayGroups
}

export default SearchResults
